import 'ui-theme/plugins/drawer/js/drawer';

const menu = UX.menu;
const {control} = menu;
menu.control = () => {
    control();
    [...document.querySelectorAll('.header .menubar .dropdown__toggle')].forEach(link => {
        link.addEventListener('click', e => {
            const url = link.getAttribute('href');
            if (url === '#') {
                return;
            }
            location.href = url;
        });
    });
};
